import { themeGet, scrollbar } from '@pocketlaw/tetris';
import styled from 'styled-components';
export const Container = styled.div `
  margin-right: ${themeGet('spacing.sm')};
  padding: ${themeGet('spacing.2xl')};
  overflow: hidden auto;
  ${scrollbar({ trackMargin: 'sm' })};
`;
